<template>
	<v-dialog v-if="laborer && auth.user_type === 1" v-model="laborAssignmentDialog" max-width="800px" transition="scroll-x-reverse-transition">
		<v-card>
			<v-card-title>
				<span class="text-h5">Send Labor Assignment?</span>
			</v-card-title>
			<v-card-text>
				<v-container class="mt-3">
					<v-row>
						<v-col>
							<v-text-field
								label="Laborer Name"
								outlined
								hide-details
								disabled
								:value="laborer.first_name + ' ' + laborer.last_name" />
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-text-field
								label="Laborer Email"
								outlined
								hide-details
								disabled
								:value="laborer.email" />
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-text-field v-model="form.subject" label="Subject" outlined hide-details></v-text-field>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-textarea v-model="form.message"
								outlined
								hide-details
								placeholder="Additional Message (optional)"
								autofocus></v-textarea>
						</v-col>
					</v-row>
				</v-container>
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					color="warning darken-1"
					text
					:disabled="form.processing"
					@click="cancel">
					Don't Send Email
				</v-btn>
				<v-btn
					color="success"
					:loading="form.processing"
					@click="sendLaborAssignment(laborer, property)">
					Send Email
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		value: {
			type: Boolean,
			default: null
		},
		project: {
			type: Object,
			default: () => {},
			required: true
		},
		property: {
			type: Object,
			default: () => {},
			required: true
		},
		laborer: {
			type: Object,
			default: () => {},
			required: true
		}
	},

	data () {
		return {
			auth: this.$page.props.auth,
			laborAssignmentDialog: this.value,
			form: this.$inertia.form({
				subject: 'Bell Oldow Environmental Job Assignment - Please Respond ASAP',
				message: ''
			})
		}
	},

	watch: {
		laborAssignmentDialog (newValue) {
			this.$emit('input', newValue)
		},

		value (newValue) {
			this.laborAssignmentDialog = newValue
		}
	},

	methods: {
		cancel () {
			this.form.reset()
			this.laborAssignmentDialog = false
		},

		sendLaborAssignment () {
			const route = this.route('send_labor_assignment', {
				'project': this.project,
				'property': this.property,
				'laborer_id': this.laborer.id
			})

			this.form.post(route, {
				only: ['properties', 'flash'],
				preserveScroll: true,
				preserveState: true,
				onSuccess: () =>  {
					this.form.reset()
					this.laborAssignmentDialog = false
				}
			})
		}
	}
}
</script>
